import { Link, LinkProps } from "react-router";

export default function SectionSubhHeading(
  props: LinkProps
): React.ReactElement {
  const { children, ...rest } = props;

  return (
    <Link data-testid="section-subheading-component" reloadDocument {...rest}>
      {children}
    </Link>
  );
}
